import React from "react";
import { connect } from "react-redux";
import {
  getTableroResumen,
  getTableroDetalle,
  limpiarDetalle,
  getTableroGuiasReparto,
  limpiarGuiasReparto,
  getTableroEficiencia,
  getTableroGuiasEficiencia,
  limpiarGuiasEficiencia,
  getGuiaDetalles,
  limpiarGuiaDetalles
} from "../../store/actions/tableroControlActions";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

import DashboardIcon from "@material-ui/icons/Dashboard";
import RefreshIcon from "@material-ui/icons/Refresh";
import SendIcon from "@material-ui/icons/Send";
import CallReceivedIcon from "@material-ui/icons/CallReceived";
import StorageIcon from "@material-ui/icons/Storage";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import FlightTakeoffIcon from "@material-ui/icons/FlightTakeoff";
import FlightLandIcon from "@material-ui/icons/FlightLand";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import AssignmentIcon from "@material-ui/icons/Assignment";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import ScheduleIcon from "@material-ui/icons/Schedule";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from "@material-ui/icons/Warning";
import MotorcycleIcon from "@material-ui/icons/Motorcycle";
import ListAltIcon from "@material-ui/icons/ListAlt";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import SearchIcon from "@material-ui/icons/Search";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";

var Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/* ═══════════════════════════════════════════════════════════════
   COLOR SYSTEM
   ═══════════════════════════════════════════════════════════════ */
var c = {
  // Foundations
  bg: "#f0f2f5",
  surface: "#ffffff",
  surfaceHover: "#fafbfc",
  border: "#e5e7eb",
  borderLight: "#f3f4f6",
  // Text
  text1: "#111827",
  text2: "#374151",
  text3: "#6b7280",
  text4: "#9ca3af",
  // Brand
  blue: "#2563eb",
  blueBg: "#eff6ff",
  blueDark: "#1e40af",
  // Semantic
  green: "#059669",
  greenBg: "#ecfdf5",
  red: "#dc2626",
  redBg: "#fef2f2",
  amber: "#d97706",
  amberBg: "#fffbeb",
  cyan: "#0891b2",
  cyanBg: "#ecfeff",
  violet: "#7c3aed",
  violetBg: "#f5f3ff",
  pink: "#db2777",
  pinkBg: "#fdf2f8"
};

/* ═══════════════════════════════════════════════════════════════
   STYLES
   ═══════════════════════════════════════════════════════════════ */
var styles = {
  root: {
    padding: "20px 24px 40px",
    background: c.bg,
    minHeight: "100vh",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  },

  /* ── Top Bar ── */
  topBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 24,
    flexWrap: "wrap",
    gap: 12
  },
  topBarLeft: {
    display: "flex",
    alignItems: "center",
    gap: 12
  },
  topBarTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: c.text1,
    margin: 0,
    letterSpacing: "-0.3px"
  },
  topBarSub: {
    fontSize: 13,
    color: c.text3,
    margin: 0,
    fontWeight: 400
  },
  topBarRight: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  refreshBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 600,
    color: c.blue,
    background: c.blueBg,
    border: "1px solid " + c.blue + "30",
    borderRadius: 8,
    cursor: "pointer",
    transition: "all 0.15s",
    "&:hover": { background: c.blue, color: "#fff" }
  },

  /* ── Section ── */
  sectionLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: c.text4,
    textTransform: "uppercase",
    letterSpacing: 1,
    margin: "28px 0 12px 2px"
  },

  /* ── Stat cards (KPI) ── */
  statCard: {
    background: c.surface,
    borderRadius: 10,
    border: "1px solid " + c.border,
    padding: "16px 18px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    position: "relative",
    overflow: "hidden",
    "&:hover": {
      borderColor: c.blue,
      boxShadow: "0 4px 16px rgba(37,99,235,0.10)"
    }
  },
  statLabel: {
    fontSize: 11,
    fontWeight: 600,
    color: c.text4,
    textTransform: "uppercase",
    letterSpacing: "0.4px",
    margin: 0
  },
  statValue: {
    fontSize: 32,
    fontWeight: 800,
    color: c.text1,
    margin: "6px 0 0",
    lineHeight: 1,
    letterSpacing: "-1px"
  },
  statIcon: {
    position: "absolute",
    top: 14,
    right: 14,
    width: 36,
    height: 36,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": { fontSize: 18, color: "#fff" }
  },

  /* ── Pipeline ── */
  pipeCard: {
    background: c.surface,
    borderRadius: 10,
    border: "1px solid " + c.border,
    overflow: "hidden",
    transition: "box-shadow 0.2s",
    "&:hover": { boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }
  },
  pipeHeader: {
    padding: "14px 16px 10px",
    display: "flex",
    alignItems: "center",
    gap: 10,
    borderBottom: "1px solid " + c.borderLight
  },
  pipeTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: c.text2,
    margin: 0
  },
  pipeBody: {
    padding: "4px 0"
  },
  pipeRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 16px",
    cursor: "pointer",
    fontSize: 13,
    transition: "background 0.1s",
    "&:hover": { background: c.surfaceHover }
  },
  pipeRowLabel: {
    color: c.text3,
    fontWeight: 500
  },
  pipeRowVal: {
    fontWeight: 700,
    color: c.text1,
    fontSize: 14,
    fontVariantNumeric: "tabular-nums"
  },
  pipeFooter: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 16px 12px",
    borderTop: "1px solid " + c.borderLight,
    fontSize: 12,
    fontWeight: 600,
    color: c.text3
  },

  /* ── Eficiencia ── */
  chartWrap: {
    background: c.surface,
    borderRadius: 10,
    border: "1px solid " + c.border,
    overflow: "hidden"
  },
  chartToolbar: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "12px 16px 0",
    gap: 4
  },
  chartTab: {
    padding: "5px 14px",
    fontSize: 12,
    fontWeight: 600,
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    transition: "all 0.15s",
    background: "transparent",
    color: c.text3
  },
  chartTabActive: {
    padding: "5px 14px",
    fontSize: 12,
    fontWeight: 600,
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    background: c.blue,
    color: "#fff"
  },
  acumWrap: {
    background: c.surface,
    borderRadius: 10,
    border: "1px solid " + c.border,
    padding: "20px 18px",
    textAlign: "center"
  },
  acumBig: {
    fontSize: 48,
    fontWeight: 800,
    lineHeight: 1,
    margin: "8px 0 2px",
    letterSpacing: "-2px"
  },
  acumRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 8px",
    borderRadius: 6,
    cursor: "pointer",
    transition: "background 0.15s",
    fontSize: 13,
    "&:hover": { background: c.surfaceHover }
  },

  /* ── Table cards ── */
  tblWrap: {
    background: c.surface,
    borderRadius: 10,
    border: "1px solid " + c.border,
    overflow: "hidden"
  },
  tblHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 16px",
    borderBottom: "1px solid " + c.borderLight
  },
  tblTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: c.text2,
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  tblBody: {
    maxHeight: 360,
    overflow: "auto",
    padding: "4px 10px 10px"
  },
  tblCount: {
    fontSize: 11,
    fontWeight: 600,
    color: c.text4,
    background: c.borderLight,
    padding: "2px 8px",
    borderRadius: 10
  },

  /* ── Badges ── */
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "3px 10px",
    borderRadius: 6,
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.2px"
  },
  bgGreen: { background: c.greenBg, color: c.green },
  bgRed: { background: c.redBg, color: c.red },
  bgAmber: { background: c.amberBg, color: c.amber },
  bgBlue: { background: c.blueBg, color: c.blue },
  bgCyan: { background: c.cyanBg, color: c.cyan },
  bgViolet: { background: c.violetBg, color: c.violet },

  /* ── Progress ── */
  progressTrack: {
    width: 56,
    height: 5,
    borderRadius: 3,
    background: c.borderLight,
    overflow: "hidden",
    display: "inline-block"
  },
  progressFill: {
    height: "100%",
    borderRadius: 3,
    transition: "width 0.3s ease"
  },

  /* ── Modal ── */
  modalBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  modalTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: c.text1
  },

  /* ── Overlay ── */
  overlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(255,255,255,0.85)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    borderRadius: 10,
    backdropFilter: "blur(2px)"
  },

  /* ── Misc ── */
  statusDot: {
    display: "inline-block",
    width: 7,
    height: 7,
    borderRadius: "50%",
    marginRight: 5
  },
  clickNum: {
    fontWeight: 700,
    color: c.blue,
    cursor: "pointer",
    "&:hover": { textDecoration: "underline" }
  }
};

var useStyles = makeStyles(styles);

/* ═══════════════════════════════════════════════════════════════
   COMPONENT
   ═══════════════════════════════════════════════════════════════ */
function TableroControl(props) {
  var classes = useStyles();

  /* ── State ── */
  var _sucursal = React.useState(localStorage.getItem("sucursal"));
  var sucursal = _sucursal[0];

  var _loading = React.useState(false);
  var loading = _loading[0];
  var setLoading = _loading[1];

  var _data = React.useState(null);
  var data = _data[0];
  var setData = _data[1];

  var _modalOpen = React.useState(false);
  var modalOpen = _modalOpen[0];
  var setModalOpen = _modalOpen[1];

  var _modalTitle = React.useState("");
  var modalTitle = _modalTitle[0];
  var setModalTitle = _modalTitle[1];

  var _detalle = React.useState(null);
  var detalle = _detalle[0];
  var setDetalle = _detalle[1];

  var _detalleLoading = React.useState(false);
  var detalleLoading = _detalleLoading[0];
  var setDetalleLoading = _detalleLoading[1];

  var _guiasModalOpen = React.useState(false);
  var guiasModalOpen = _guiasModalOpen[0];
  var setGuiasModalOpen = _guiasModalOpen[1];

  var _guiasModalTitle = React.useState("");
  var guiasModalTitle = _guiasModalTitle[0];
  var setGuiasModalTitle = _guiasModalTitle[1];

  var _guiasReparto = React.useState(null);
  var guiasReparto = _guiasReparto[0];
  var setGuiasReparto = _guiasReparto[1];

  var _guiasRepartoLoading = React.useState(false);
  var guiasRepartoLoading = _guiasRepartoLoading[0];
  var setGuiasRepartoLoading = _guiasRepartoLoading[1];

  var _eficienciaChart = React.useState(null);
  var eficienciaChart = _eficienciaChart[0];
  var setEficienciaChart = _eficienciaChart[1];

  var _chartView = React.useState("diario");
  var chartView = _chartView[0];
  var setChartView = _chartView[1];

  var _fechaRepartoLocal = React.useState("");
  var fechaRepartoLocal = _fechaRepartoLocal[0];
  var setFechaRepartoLocal = _fechaRepartoLocal[1];

  var _guiasEficiencia = React.useState(null);
  var guiasEficiencia = _guiasEficiencia[0];
  var setGuiasEficiencia = _guiasEficiencia[1];

  var _guiasEficienciaLoading = React.useState(false);
  var guiasEficienciaLoading = _guiasEficienciaLoading[0];
  var setGuiasEficienciaLoading = _guiasEficienciaLoading[1];

  var _guiaDetalles = React.useState(null);
  var guiaDetalles = _guiaDetalles[0];
  var setGuiaDetalles = _guiaDetalles[1];

  var _guiaDetallesLoading = React.useState(false);
  var guiaDetallesLoading = _guiaDetallesLoading[0];
  var setGuiaDetallesLoading = _guiaDetallesLoading[1];

  var _guiaDetallesModalOpen = React.useState(false);
  var guiaDetallesModalOpen = _guiaDetallesModalOpen[0];
  var setGuiaDetallesModalOpen = _guiaDetallesModalOpen[1];

  /* ── Effects ── */
  React.useEffect(function () { cargarDatos(); }, []);
  React.useEffect(function () { if (props.tableroData) { setData(props.tableroData); setLoading(false); } }, [props.tableroData]);
  React.useEffect(function () { if (props.tableroDetalle) { setDetalle(props.tableroDetalle); setDetalleLoading(false); } }, [props.tableroDetalle]);
  React.useEffect(function () { if (props.tableroLoading) { setLoading(true); } }, [props.tableroLoading]);
  React.useEffect(function () { if (props.tableroGuiasReparto) { setGuiasReparto(props.tableroGuiasReparto); setGuiasRepartoLoading(false); } }, [props.tableroGuiasReparto]);
  React.useEffect(function () { if (props.tableroGuiasEficiencia) { setGuiasEficiencia(props.tableroGuiasEficiencia); setGuiasEficienciaLoading(false); } }, [props.tableroGuiasEficiencia]);
  React.useEffect(function () { if (props.tableroGuiaDetalles) { setGuiaDetalles(props.tableroGuiaDetalles); setGuiaDetallesLoading(false); } }, [props.tableroGuiaDetalles]);
  React.useEffect(function () { if (props.tableroGuiaDetallesLoading) { setGuiaDetallesLoading(true); } }, [props.tableroGuiaDetallesLoading]);
  React.useEffect(function () { if (props.tableroEficiencia) { setEficienciaChart(props.tableroEficiencia); } }, [props.tableroEficiencia]);

  /* ── Actions ── */
  var cargarDatos = function () {
    setLoading(true);
    setEficienciaChart(null);
    props.getTableroResumen(sucursal);
    props.getTableroEficiencia(sucursal);
  };

  var verDetalle = function (tipo, titulo, extraParam) {
    setModalTitle(titulo);
    setModalOpen(true);
    setDetalleLoading(true);
    setDetalle(null);
    if (tipo === "UNIDADES_LOCALES_RUTA") { setFechaRepartoLocal(""); }
    props.getTableroDetalle(sucursal, tipo, extraParam || null);
  };

  var buscarRepartosPorFecha = function (fecha) {
    setFechaRepartoLocal(fecha);
    setDetalleLoading(true);
    setDetalle(null);
    props.getTableroDetalle(sucursal, "UNIDADES_LOCALES_RUTA", fecha || null);
  };

  var cerrarModal = function () {
    setModalOpen(false);
    setDetalle(null);
    props.limpiarDetalle();
  };

  var verGuiasReparto = function (repartoId, folioReparto, unidad) {
    setGuiasModalTitle("Guias del Reparto #" + folioReparto + " — Unidad " + unidad);
    setGuiasModalOpen(true);
    setGuiasRepartoLoading(true);
    setGuiasReparto(null);
    props.getTableroGuiasReparto(sucursal, repartoId);
  };

  var cerrarGuiasModal = function () {
    setGuiasModalOpen(false);
    setGuiasReparto(null);
    props.limpiarGuiasReparto();
  };

  var verGuiasEficiencia = function (estado, label) {
    setGuiasModalTitle("Guias " + label + " — " + (eficienciaChart.acumulado ? eficienciaChart.acumulado.mes : "Mes Actual"));
    setGuiasModalOpen(true);
    setGuiasEficienciaLoading(true);
    setGuiasEficiencia(null);
    props.getTableroGuiasEficiencia(sucursal, estado);
  };

  var cerrarGuiasEficienciaModal = function () {
    setGuiasModalOpen(false);
    setGuiasEficiencia(null);
    props.limpiarGuiasEficiencia();
  };

  var verDetallesGuia = function (numeroGuia) {
    setGuiaDetallesLoading(true);
    setGuiaDetalles(null);
    setGuiaDetallesModalOpen(true);
    props.getGuiaDetalles(numeroGuia);
  };

  var cerrarDetallesGuia = function () {
    setGuiaDetallesModalOpen(false);
    setGuiaDetalles(null);
    props.limpiarGuiaDetalles();
  };

  /* ── Helpers ── */
  var getEstadoBadge = function (estado) {
    var map = {
      "EN TRANSITO": classes.bgCyan,
      "ALMACEN ORIGEN": classes.bgAmber,
      "ALMACEN DESTINO": classes.bgAmber,
      "ALMACEN TRASBORDO": classes.bgViolet,
      "EN REPARTO EAD": classes.bgGreen,
      "POR RECIBIR": classes.bgAmber,
      "AUTORIZACION PARA CANCELAR": classes.bgRed,
      "AUTORIZACION PARA SUSTITUIR": classes.bgRed
    };
    return map[estado] || classes.bgBlue;
  };

  var getTiempoEnRuta = function (u) {
    if (u.fecha_salida && u.hora_salida && u.hora_salida !== "00:00:00") {
      var salida = new Date(u.fecha_salida + " " + u.hora_salida);
      var ahora = new Date();
      var diff = Math.floor((ahora - salida) / 60000);
      if (diff < 60) return diff + "m";
      return Math.floor(diff / 60) + "h " + (diff % 60) + "m";
    }
    return "—";
  };

  var pipelineSum = function (obj) {
    if (!obj) return 0;
    return Object.values(obj).reduce(function (a, b) { return typeof b === "number" ? a + b : a; }, 0);
  };

  var efColor = function (pct) {
    if (pct >= 70) return c.green;
    if (pct >= 50) return c.amber;
    return c.red;
  };

  var getChartOptions = function (datos, titulo) {
    if (!datos || datos.length === 0) return null;
    return {
      chart: { type: "column", height: 280, style: { fontFamily: "inherit" }, backgroundColor: "transparent" },
      title: { text: titulo, style: { fontSize: "13px", fontWeight: "700", color: c.text2 } },
      xAxis: {
        categories: datos.map(function (d) { return d.label; }),
        crosshair: true,
        labels: { style: { fontSize: "9px", color: c.text4 } }
      },
      yAxis: [
        { title: { text: null }, min: 0, gridLineColor: "#f3f4f6", labels: { style: { fontSize: "10px" } } },
        { title: { text: null }, min: 0, max: 100, opposite: true, labels: { format: "{value}%", style: { fontSize: "10px" } }, gridLineWidth: 0 }
      ],
      tooltip: { shared: true, borderRadius: 8, borderWidth: 0, shadow: { color: "rgba(0,0,0,0.08)", offsetX: 0, offsetY: 4, width: 12 } },
      plotOptions: {
        column: { stacking: "normal", borderRadius: 3, borderWidth: 0, pointPadding: 0.15 },
        spline: { lineWidth: 2, marker: { radius: 3 } }
      },
      legend: { align: "center", verticalAlign: "bottom", layout: "horizontal", itemStyle: { fontSize: "10px", color: c.text3 } },
      series: [
        { name: "A Tiempo", type: "column", data: datos.map(function (d) { return d.a_tiempo; }), color: "#22c55e" },
        { name: "Fuera de Tiempo", type: "column", data: datos.map(function (d) { return d.despues; }), color: "#ef4444" },
        { name: "Pendientes", type: "column", data: datos.map(function (d) { return d.pendientes; }), color: "#f59e0b" },
        { name: "Efectividad", type: "spline", yAxis: 1, color: c.blue, data: datos.map(function (d) { return d.porcentaje; }), tooltip: { valueSuffix: "%" } }
      ],
      credits: { enabled: false }
    };
  };

  /* ── Derived data ── */
  var metricas = data ? data.metricas : null;
  var metricasHoy = data ? data.metricas_hoy : null;
  var acum = eficienciaChart ? eficienciaChart.acumulado : null;

  /* ── Sub-components ── */
  var Loader = function (p) {
    return (
      <div className={classes.overlay}>
        <CircularProgress size={24} style={{ color: c.blue }} />
        <p style={{ marginTop: 8, color: c.text4, fontSize: 12 }}>{p.text || "Cargando..."}</p>
      </div>
    );
  };

  var EyeBtn = function (p) {
    return (
      <Tooltip title="Ver detalle" placement="top">
        <IconButton size="small" style={{ padding: 4, color: c.blue }} onClick={function () { verDetallesGuia(p.guia); }}>
          <VisibilityIcon style={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    );
  };

  var extractText = function (node) {
    if (node == null) return "";
    if (typeof node === "string" || typeof node === "number") return String(node);
    if (Array.isArray(node)) return node.map(extractText).join(" ");
    if (node.props) {
      var ch = node.props.children;
      if (ch) return extractText(ch);
      if (node.props.value) return String(node.props.value);
    }
    return "";
  };

  var FilterTable = function (fp) {
    var _ft = React.useState("");
    var filterText = _ft[0];
    var setFilterText = _ft[1];
    var headers = fp.tableHead || [];
    var initColFilters = function () {
      var obj = {};
      headers.forEach(function (h, i) { obj[i] = ""; });
      return obj;
    };
    var _cf = React.useState(initColFilters);
    var colFilters = _cf[0];
    var setColFilters = _cf[1];
    var _showColFilters = React.useState(false);
    var showColFilters = _showColFilters[0];
    var setShowColFilters = _showColFilters[1];
    var rows = fp.tableData || [];

    var hasActiveColFilter = Object.values(colFilters).some(function (v) { return v !== ""; });

    var filtered = rows.filter(function (row) {
      if (!Array.isArray(row)) return true;
      if (filterText) {
        var txt = row.map(extractText).join(" ").toLowerCase();
        if (txt.indexOf(filterText.toLowerCase()) === -1) return false;
      }
      if (hasActiveColFilter) {
        for (var i = 0; i < headers.length; i++) {
          if (colFilters[i] && colFilters[i] !== "") {
            var cellText = extractText(row[i]).toLowerCase();
            if (cellText.indexOf(colFilters[i].toLowerCase()) === -1) return false;
          }
        }
      }
      return true;
    });

    var clearAllFilters = function () {
      setFilterText("");
      setColFilters(initColFilters());
    };

    var activeCount = (filterText ? 1 : 0) + Object.values(colFilters).filter(function (v) { return v !== ""; }).length;

    return (
      <div>
        <div style={{ padding: "8px 6px 4px", display: "flex", alignItems: "center", gap: 6 }}>
          <SearchIcon style={{ fontSize: 16, color: c.text4 }} />
          <input
            type="text"
            placeholder="Buscar en toda la tabla..."
            value={filterText}
            onChange={function (e) { setFilterText(e.target.value); }}
            style={{ flex: 1, padding: "6px 10px", border: "1px solid " + c.borderLight, borderRadius: 6, fontSize: 12, color: c.text1, outline: "none", background: c.surfaceHover }}
          />
          <button
            onClick={function () { setShowColFilters(!showColFilters); }}
            title="Filtros por columna"
            style={{
              display: "inline-flex", alignItems: "center", gap: 4, padding: "5px 10px",
              fontSize: 11, fontWeight: 600, border: "1px solid " + (showColFilters || hasActiveColFilter ? c.blue + "60" : c.borderLight),
              borderRadius: 6, cursor: "pointer", background: showColFilters || hasActiveColFilter ? c.blueBg : c.surfaceHover,
              color: showColFilters || hasActiveColFilter ? c.blue : c.text3, whiteSpace: "nowrap", transition: "all 0.15s"
            }}
          >
            <SearchIcon style={{ fontSize: 13 }} />
            Columnas
          </button>
          {activeCount > 0 && (
            <button
              onClick={clearAllFilters}
              title="Limpiar filtros"
              style={{
                display: "inline-flex", alignItems: "center", padding: "5px 8px",
                fontSize: 11, fontWeight: 600, border: "1px solid " + c.red + "40",
                borderRadius: 6, cursor: "pointer", background: c.redBg, color: c.red, whiteSpace: "nowrap"
              }}
            >
              <CloseIcon style={{ fontSize: 13 }} />
            </button>
          )}
        </div>
        {showColFilters && (
          <div style={{ display: "flex", gap: 4, padding: "2px 6px 6px", flexWrap: "wrap" }}>
            {headers.map(function (h, i) {
              return (
                <input
                  key={i}
                  type="text"
                  placeholder={h}
                  value={colFilters[i] || ""}
                  onChange={function (e) {
                    var updated = Object.assign({}, colFilters);
                    updated[i] = e.target.value;
                    setColFilters(updated);
                  }}
                  style={{
                    flex: "1 1 0", minWidth: 60, maxWidth: 140, padding: "4px 8px",
                    border: "1px solid " + (colFilters[i] ? c.blue + "50" : c.borderLight),
                    borderRadius: 5, fontSize: 11, color: c.text1, outline: "none",
                    background: colFilters[i] ? c.blueBg : c.surfaceHover
                  }}
                />
              );
            })}
          </div>
        )}
        {activeCount > 0 && (
          <div style={{ padding: "0 8px 4px", fontSize: 11, color: c.text4 }}>
            {filtered.length} de {rows.length} registros
          </div>
        )}
        <Table tableHead={fp.tableHead} tableData={filtered} />
      </div>
    );
  };

  /* ═══════════════════════════════════════════════════════════════
     RENDER
     ═══════════════════════════════════════════════════════════════ */
  return (
    <div className={classes.root}>

      {/* ────── TOP BAR ────── */}
      <div className={classes.topBar}>
        <div className={classes.topBarLeft}>
          <DashboardIcon style={{ fontSize: 24, color: c.blue }} />
          <div>
            <h1 className={classes.topBarTitle}>Tablero de Control</h1>
            <p className={classes.topBarSub}>
              {data && data.sucursal
                ? data.sucursal.prefijo + " — " + data.sucursal.descripcion
                : "Cargando..."}
            </p>
          </div>
        </div>
        <div className={classes.topBarRight}>
          <button className={classes.refreshBtn} onClick={cargarDatos} disabled={loading}>
            <RefreshIcon style={{ fontSize: 16 }} />
            {loading ? "Actualizando..." : "Actualizar"}
          </button>
        </div>
      </div>

      {/* ────── LOADING STATE ────── */}
      {loading && !data ? (
        <div style={{ textAlign: "center", padding: "100px 20px" }}>
          <CircularProgress size={36} style={{ color: c.blue }} />
          <p style={{ marginTop: 14, color: c.text3, fontSize: 14 }}>Cargando tablero de control...</p>
        </div>

      ) : data ? (
        <div>

          {/* ═══ KPI STRIP ═══ */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 10, position: "relative" }}>
            {loading && <Loader text="Actualizando..." />}

            <div className={classes.statCard} onClick={function () { verDetalle("GUIAS_HOY", "Guias Generadas Hoy"); }}>
              <div className={classes.statIcon} style={{ background: c.blue }}><AssignmentIcon /></div>
              <p className={classes.statLabel}>Guias Hoy</p>
              <h2 className={classes.statValue}>{metricasHoy ? metricasHoy.guias_hoy : 0}</h2>
            </div>

            <div className={classes.statCard} onClick={function () { verDetalle("EMBARQUES_HOY", "Embarques del Dia"); }}>
              <div className={classes.statIcon} style={{ background: c.amber }}><ArrowUpwardIcon /></div>
              <p className={classes.statLabel}>Embarques</p>
              <h2 className={classes.statValue}>{metricasHoy ? metricasHoy.embarques_hoy : 0}</h2>
            </div>

            <div className={classes.statCard} onClick={function () { verDetalle("RECEPCIONES_HOY", "Recepciones del Dia"); }}>
              <div className={classes.statIcon} style={{ background: c.green }}><CallReceivedIcon /></div>
              <p className={classes.statLabel}>Recepciones</p>
              <h2 className={classes.statValue}>{metricasHoy ? metricasHoy.recepciones_hoy : 0}</h2>
            </div>

            <div className={classes.statCard} style={{ cursor: "default" }}>
              <div className={classes.statIcon} style={{ background: c.violet }}><LocalShippingIcon /></div>
              <p className={classes.statLabel}>Ruta Foraneo</p>
              <h2 className={classes.statValue}>{data.unidades_en_ruta_count || 0}</h2>
            </div>

            <div className={classes.statCard} style={{ cursor: "default" }}>
              <div className={classes.statIcon} style={{ background: c.cyan }}><LocationOnIcon /></div>
              <p className={classes.statLabel}>En Sucursal</p>
              <h2 className={classes.statValue}>{data.unidades_en_sucursal ? data.unidades_en_sucursal.length : 0}</h2>
            </div>

            <div className={classes.statCard} onClick={function () { verDetalle("DELIVERY", "En Reparto EAD — Ultima Milla"); }}>
              <div className={classes.statIcon} style={{ background: c.pink }}><MotorcycleIcon /></div>
              <p className={classes.statLabel}>Reparto EAD</p>
              <h2 className={classes.statValue}>{metricas ? metricas.ultima_milla : 0}</h2>
            </div>
          </div>

          {/* ═══ PIPELINE ═══ */}
          <p className={classes.sectionLabel}>Pipeline Logistico</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 10, position: "relative" }}>
            {loading && <Loader text="Cargando pipeline..." />}

            {/* Enviadas */}
            <div className={classes.pipeCard}>
              <div className={classes.pipeHeader}>
                <SendIcon style={{ fontSize: 16, color: c.cyan }} />
                <h4 className={classes.pipeTitle}>Enviadas desde aqui</h4>
              </div>
              <div className={classes.pipeBody}>
                <div className={classes.pipeRow} onClick={function () { verDetalle("ORIGIN", "Origen — Enviadas"); }}>
                  <span className={classes.pipeRowLabel}>Origen</span>
                  <span className={classes.pipeRowVal}>{metricas && metricas.enviadas_desde_aqui ? metricas.enviadas_desde_aqui.origen : 0}</span>
                </div>
                <div className={classes.pipeRow} onClick={function () { verDetalle("TRANSIT_OUT", "En Transito — Enviadas"); }}>
                  <span className={classes.pipeRowLabel}>En transito</span>
                  <span className={classes.pipeRowVal}>{metricas && metricas.enviadas_desde_aqui ? metricas.enviadas_desde_aqui.en_transito : 0}</span>
                </div>
                <div className={classes.pipeRow} onClick={function () { verDetalle("ENVIADAS_TRASBORDO", "Trasbordo — Enviadas"); }}>
                  <span className={classes.pipeRowLabel}>Trasbordo</span>
                  <span className={classes.pipeRowVal}>{metricas && metricas.enviadas_desde_aqui ? metricas.enviadas_desde_aqui.trasbordo : 0}</span>
                </div>
                <div className={classes.pipeRow} onClick={function () { verDetalle("ENVIADAS_PORRECIBIR", "Por Recibir — Enviadas"); }}>
                  <span className={classes.pipeRowLabel}>Por recibir</span>
                  <span className={classes.pipeRowVal}>{metricas && metricas.enviadas_desde_aqui ? metricas.enviadas_desde_aqui.por_recibir : 0}</span>
                </div>
              </div>
              <div className={classes.pipeFooter}>
                <span>Total</span>
                <span style={{ color: c.text1, fontWeight: 700 }}>{metricas ? pipelineSum(metricas.enviadas_desde_aqui) : 0}</span>
              </div>
            </div>

            {/* Hacia mi sucursal */}
            <div className={classes.pipeCard}>
              <div className={classes.pipeHeader}>
                <CallReceivedIcon style={{ fontSize: 16, color: c.amber }} />
                <h4 className={classes.pipeTitle}>Hacia mi sucursal</h4>
              </div>
              <div className={classes.pipeBody}>
                <div className={classes.pipeRow} onClick={function () { verDetalle("HACIA_ORIGEN", "Origen — Hacia mi Sucursal"); }}>
                  <span className={classes.pipeRowLabel}>Origen</span>
                  <span className={classes.pipeRowVal}>{metricas && metricas.hacia_mi_sucursal ? metricas.hacia_mi_sucursal.origen : 0}</span>
                </div>
                <div className={classes.pipeRow} onClick={function () { verDetalle("INBOUND", "En Transito — Entrando"); }}>
                  <span className={classes.pipeRowLabel}>En transito</span>
                  <span className={classes.pipeRowVal}>{metricas && metricas.hacia_mi_sucursal ? metricas.hacia_mi_sucursal.en_transito : 0}</span>
                </div>
                <div className={classes.pipeRow} onClick={function () { verDetalle("TRASBORDO", "Trasbordo"); }}>
                  <span className={classes.pipeRowLabel}>Trasbordo</span>
                  <span className={classes.pipeRowVal}>{metricas && metricas.hacia_mi_sucursal ? metricas.hacia_mi_sucursal.trasbordo : 0}</span>
                </div>
                <div className={classes.pipeRow} onClick={function () { verDetalle("PORRECIBIR", "Por Recibir"); }}>
                  <span className={classes.pipeRowLabel}>Por recibir</span>
                  <span className={classes.pipeRowVal}>{metricas && metricas.hacia_mi_sucursal ? metricas.hacia_mi_sucursal.por_recibir : 0}</span>
                </div>
              </div>
              <div className={classes.pipeFooter}>
                <span>Total</span>
                <span style={{ color: c.text1, fontWeight: 700 }}>{metricas ? pipelineSum(metricas.hacia_mi_sucursal) : 0}</span>
              </div>
            </div>

            {/* Inventario */}
            <div className={classes.pipeCard}>
              <div className={classes.pipeHeader}>
                <StorageIcon style={{ fontSize: 16, color: c.green }} />
                <h4 className={classes.pipeTitle}>Inventario</h4>
              </div>
              <div className={classes.pipeBody}>
                <div className={classes.pipeRow} onClick={function () { verDetalle("EAD", "EAD — Almacen Destino"); }}>
                  <span className={classes.pipeRowLabel}>EAD</span>
                  <span className={classes.pipeRowVal}>{metricas && metricas.inventario ? metricas.inventario.ead : 0}</span>
                </div>
                <div className={classes.pipeRow} onClick={function () { verDetalle("OCURRE", "Ocurre — Almacen Destino"); }}>
                  <span className={classes.pipeRowLabel}>Ocurre</span>
                  <span className={classes.pipeRowVal}>{metricas && metricas.inventario ? metricas.inventario.ocurre : 0}</span>
                </div>
                <div className={classes.pipeRow} onClick={function () { verDetalle("TRASBORDO", "Trasbordo"); }}>
                  <span className={classes.pipeRowLabel}>Trasbordo</span>
                  <span className={classes.pipeRowVal}>{metricas && metricas.inventario ? metricas.inventario.trasbordo : 0}</span>
                </div>
              </div>
              <div className={classes.pipeFooter}>
                <span>Total</span>
                <span style={{ color: c.text1, fontWeight: 700 }}>{metricas ? pipelineSum(metricas.inventario) : 0}</span>
              </div>
            </div>

            {/* Unidades Locales */}
            <div className={classes.pipeCard}>
              <div className={classes.pipeHeader}>
                <LocalShippingIcon style={{ fontSize: 16, color: c.pink }} />
                <h4 className={classes.pipeTitle}>Unidades locales</h4>
              </div>
              <div className={classes.pipeBody}>
                <div className={classes.pipeRow} onClick={function () { verDetalle("UNIDADES_LOCALES_RUTA", "Unidades Locales en Ruta"); }}>
                  <span className={classes.pipeRowLabel}>En ruta</span>
                  <span className={classes.pipeRowVal} style={{ color: c.blue }}>{data.unidades_locales ? data.unidades_locales.en_ruta_count : 0}</span>
                </div>
                <div className={classes.pipeRow} onClick={function () { verDetalle("UNIDADES_LOCALES_SUCURSAL", "Unidades Locales en Sucursal"); }}>
                  <span className={classes.pipeRowLabel}>En sucursal</span>
                  <span className={classes.pipeRowVal}>{data.unidades_locales ? data.unidades_locales.en_sucursal_count : 0}</span>
                </div>
              </div>
              <div className={classes.pipeFooter}>
                <span>Total</span>
                <span style={{ color: c.text1, fontWeight: 700 }}>{data.unidades_locales ? (data.unidades_locales.en_ruta_count || 0) + (data.unidades_locales.en_sucursal_count || 0) : 0}</span>
              </div>
            </div>
          </div>

          {/* ═══ EFICIENCIA ═══ */}
          <p className={classes.sectionLabel}>Eficiencia de Entrega</p>
          {props.tableroEficienciaLoading ? (
            <div style={{ textAlign: "center", padding: 60 }}>
              <CircularProgress size={28} style={{ color: c.blue }} />
              <p style={{ marginTop: 10, color: c.text4, fontSize: 12 }}>Cargando eficiencia...</p>
            </div>
          ) : eficienciaChart ? (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 12, alignItems: "start" }}>
              {/* Chart */}
              <div className={classes.chartWrap}>
                <div className={classes.chartToolbar}>
                  {["diario", "semanal", "mensual"].map(function (v) {
                    return (
                      <button
                        key={v}
                        className={chartView === v ? classes.chartTabActive : classes.chartTab}
                        onClick={function () { setChartView(v); }}
                      >
                        {v.charAt(0).toUpperCase() + v.slice(1)}
                      </button>
                    );
                  })}
                </div>
                <div style={{ padding: "8px 12px 12px" }}>
                  {chartView === "diario" && eficienciaChart.diario && getChartOptions(eficienciaChart.diario, "Efectividad Diaria (30 dias)") ? (
                    <HighchartsReact highcharts={Highcharts} options={getChartOptions(eficienciaChart.diario, "Efectividad Diaria (30 dias)")} />
                  ) : null}
                  {chartView === "semanal" && eficienciaChart.semanal && getChartOptions(eficienciaChart.semanal, "Efectividad Semanal") ? (
                    <HighchartsReact highcharts={Highcharts} options={getChartOptions(eficienciaChart.semanal, "Efectividad Semanal")} />
                  ) : null}
                  {chartView === "mensual" && eficienciaChart.mensual && getChartOptions(eficienciaChart.mensual, "Efectividad Mensual") ? (
                    <HighchartsReact highcharts={Highcharts} options={getChartOptions(eficienciaChart.mensual, "Efectividad Mensual")} />
                  ) : null}
                </div>
              </div>

              {/* Acumulado */}
              <div className={classes.acumWrap}>
                <p style={{ margin: 0, fontSize: 11, fontWeight: 700, color: c.text4, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Acumulado Mes Actual
                </p>
                <p style={{ margin: "2px 0 0", fontSize: 12, color: c.text4 }}>{acum ? acum.mes : "—"}</p>
                {acum ? (
                  <div>
                    <h1 className={classes.acumBig} style={{ color: efColor(acum.porcentaje || 0) }}>
                      {acum.porcentaje || 0}%
                    </h1>
                    <p style={{ margin: "0 0 16px", fontSize: 11, color: c.text4 }}>Efectividad</p>

                    <div style={{ textAlign: "left" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid " + c.borderLight, fontSize: 13 }}>
                        <span style={{ color: c.text3 }}>Total Guias</span>
                        <span style={{ fontWeight: 700, color: c.blue }}>{acum.total || 0}</span>
                      </div>

                      <div className={classes.acumRow} onClick={function () { verGuiasEficiencia("a_tiempo", "A Tiempo"); }}>
                        <span style={{ color: c.green, fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}>
                          <CheckCircleIcon style={{ fontSize: 14 }} /> A tiempo
                        </span>
                        <span style={{ fontWeight: 700, color: c.green }}>{acum.a_tiempo || 0}</span>
                      </div>

                      <div className={classes.acumRow} onClick={function () { verGuiasEficiencia("despues", "Fuera de Tiempo"); }}>
                        <span style={{ color: c.red, fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}>
                          <WarningIcon style={{ fontSize: 14 }} /> Fuera de tiempo
                        </span>
                        <span style={{ fontWeight: 700, color: c.red }}>{acum.despues || 0}</span>
                      </div>

                      <div className={classes.acumRow} onClick={function () { verGuiasEficiencia("pendientes", "Pendientes"); }}>
                        <span style={{ color: c.amber, fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}>
                          <ScheduleIcon style={{ fontSize: 14 }} /> Pendientes
                        </span>
                        <span style={{ fontWeight: 700, color: c.amber }}>{acum.pendientes || 0}</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={{ padding: 30 }}><CircularProgress size={20} style={{ color: c.blue }} /></div>
                )}
              </div>
            </div>
          ) : null}

          {/* ═══ TABLAS OPERATIVAS ═══ */}
          <p className={classes.sectionLabel}>Detalle Operativo</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12, position: "relative" }}>
            {loading && <Loader text="Cargando datos..." />}

            {/* Unidades en Sucursal */}
            <div className={classes.tblWrap}>
              <div className={classes.tblHeader}>
                <h4 className={classes.tblTitle}>
                  <FlightLandIcon style={{ fontSize: 16, color: c.cyan }} /> Unidades en Sucursal (Foraneas)
                </h4>
                <span className={classes.tblCount}>{data.unidades_en_sucursal ? data.unidades_en_sucursal.length : 0}</span>
              </div>
              <div className={classes.tblBody}>
                <FilterTable
                  tableHead={["Bitacora", "Unidad", "Recibio", "Ruta", "Llegada"]}
                  tableData={
                    data.unidades_en_sucursal && data.unidades_en_sucursal.length > 0
                      ? data.unidades_en_sucursal.map(function (u) {
                          return [u.idbitacora || "-", u.unidad || "-", u.recibio || "-", u.ruta || "-", u.fecha_llegada_real || "-"];
                        })
                      : [["Sin unidades", "", "", "", ""]]
                  }
                />
              </div>
            </div>

            {/* Embarques Recientes */}
            <div className={classes.tblWrap}>
              <div className={classes.tblHeader}>
                <h4 className={classes.tblTitle}>
                  <FlightTakeoffIcon style={{ fontSize: 16, color: c.amber }} /> Embarques Recientes
                </h4>
              </div>
              <div className={classes.tblBody}>
                <FilterTable
                  tableHead={["Bitacora", "Embarque", "Unidad", "Fecha", "Guias"]}
                  tableData={
                    data.embarques && data.embarques.length > 0
                      ? data.embarques.map(function (e) {
                          return [
                            "#" + (e.folio_bitacora || "-"),
                            "#" + (e.folio_embarque || "-"),
                            e.unidad || "-",
                            e.fecha || "-",
                            <span
                              className={classes.clickNum}
                              onClick={function () { verDetalle("EMBARQUES_RECIENTES_GUIAS", "Guias del Embarque #" + (e.folio_embarque || "-"), e.id); }}
                            >
                              {e.total_guias || "0"}
                            </span>
                          ];
                        })
                      : [["Sin embarques", "", "", "", ""]]
                  }
                />
              </div>
            </div>

            {/* Monitor de Unidades */}
            <div className={classes.tblWrap}>
              <div className={classes.tblHeader}>
                <h4 className={classes.tblTitle}>
                  <LocalShippingIcon style={{ fontSize: 16, color: c.green }} /> Monitor de Unidades (Arribos)
                </h4>
              </div>
              <div className={classes.tblBody}>
                <FilterTable
                  tableHead={["Bitacora", "Unidad", "Ruta", "Fecha", "Salida", "Estado"]}
                  tableData={
                    data.unidades_en_ruta && data.unidades_en_ruta.length > 0
                      ? data.unidades_en_ruta.map(function (u) {
                          var t = getTiempoEnRuta(u);
                          return [
                            "#" + (u.idbitacora || "-"),
                            u.unidad_actual || "-",
                            <div>
                              <div style={{ fontSize: 12, fontWeight: 600 }}>{u.origenes || ""}</div>
                              <div style={{ fontSize: 10, color: c.text4 }}>{u.ruta || ""}</div>
                            </div>,
                            u.fecha_salida || "-",
                            u.hora_salida || "00:00",
                            <div style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 12 }}>
                              <span className={classes.statusDot} style={{ background: t !== "—" ? c.green : c.amber }} />
                              <span style={{ fontWeight: 600 }}>{t}</span>
                            </div>
                          ];
                        })
                      : [["Sin unidades en ruta", "", "", "", "", ""]]
                  }
                />
              </div>
            </div>

            {/* Recepciones Recientes */}
            <div className={classes.tblWrap}>
              <div className={classes.tblHeader}>
                <h4 className={classes.tblTitle}>
                  <CallReceivedIcon style={{ fontSize: 16, color: c.green }} /> Recepciones Recientes
                </h4>
              </div>
              <div className={classes.tblBody}>
                <FilterTable
                  tableHead={["Embarque", "Bitacora", "Unidad", "Fecha", "Guias"]}
                  tableData={
                    data.recepciones && data.recepciones.length > 0
                      ? data.recepciones.map(function (r) {
                          return [
                            <span style={{ color: c.green, fontWeight: 600 }}>{"#" + (r.folio_embarque || "-")}</span>,
                            <span style={{ color: c.amber, fontWeight: 600 }}>{"#" + (r.folio_bitacora || "-")}</span>,
                            r.unidad || "-",
                            r.fecha || "-",
                            <span
                              className={classes.clickNum}
                              onClick={function () { verDetalle("RECEPCIONES_RECIENTES_GUIAS", "Guias de la Recepcion #" + (r.folio_embarque || "-"), r.id); }}
                            >
                              {r.total_guias || "0"}
                            </span>
                          ];
                        })
                      : [["Sin recepciones", "", "", "", ""]]
                  }
                />
              </div>
            </div>

            {/* Programacion de Llegadas */}
            <div className={classes.tblWrap} style={{ gridColumn: "1 / -1" }}>
              <div className={classes.tblHeader}>
                <h4 className={classes.tblTitle}>
                  <ScheduleIcon style={{ fontSize: 16, color: c.amber }} /> Programacion de Llegadas
                </h4>
              </div>
              <div className={classes.tblBody}>
                <FilterTable
                  tableHead={["Bitacora", "Unidad", "Ruta", "Fecha Prog.", "Ubicacion Actual", "Estado"]}
                  tableData={
                    data.programacion_llegadas && data.programacion_llegadas.length > 0
                      ? data.programacion_llegadas.map(function (p) {
                          return [
                            "#" + (p.idbitacora || "-"),
                            p.unidad || "-",
                            p.ruta || "-",
                            p.fecha_prog || "-",
                            p.ubicacion_actual || "-",
                            <span className={classes.badge + " " + classes.bgAmber}>{p.estado || "Pendiente"}</span>
                          ];
                        })
                      : [["Sin llegadas programadas", "", "", "", "", ""]]
                  }
                />
              </div>
            </div>
          </div>

        </div>
      ) : (
        <div style={{ textAlign: "center", padding: 80 }}>
          <p style={{ color: c.text4, fontSize: 14 }}>No se pudieron cargar los datos.</p>
          <Button color="info" onClick={cargarDatos}><RefreshIcon /> Reintentar</Button>
        </div>
      )}

      {/* ═══════════════════════════════════════════════════════════
         MODAL — Detalle
         ═══════════════════════════════════════════════════════════ */}
      <Dialog open={modalOpen} TransitionComponent={Transition} keepMounted onClose={cerrarModal} maxWidth="lg" fullWidth
        PaperProps={{ style: { borderRadius: 12, maxHeight: "85vh" } }}>
        <DialogTitle disableTypography style={{ padding: "16px 20px 12px", borderBottom: "1px solid " + c.borderLight }}>
          <div className={classes.modalBar}>
            <span className={classes.modalTitle}>{modalTitle}</span>
            <IconButton size="small" onClick={cerrarModal}><CloseIcon /></IconButton>
          </div>
        </DialogTitle>
        <DialogContent style={{ padding: "16px 20px 20px" }}>
          {detalleLoading ? (
            <div style={{ textAlign: "center", padding: "50px 0" }}>
              <CircularProgress size={28} style={{ color: c.blue }} />
              <p style={{ marginTop: 10, color: c.text4, fontSize: 13 }}>Cargando...</p>
            </div>

          ) : detalle && detalle.tipo === "UNIDADES_LOCALES_RUTA" && detalle.items ? (
            <div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, flexWrap: "wrap", gap: 10 }}>
                <p style={{ margin: 0, color: c.text3, fontSize: 13 }}>
                  {detalle.total} unidades{fechaRepartoLocal ? " — " + fechaRepartoLocal : ""}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <input
                    type="date"
                    value={fechaRepartoLocal}
                    onChange={function (e) { buscarRepartosPorFecha(e.target.value); }}
                    style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid " + c.border, fontSize: 13, color: c.text1, outline: "none" }}
                  />
                  {fechaRepartoLocal ? (
                    <button onClick={function () { buscarRepartosPorFecha(""); }} style={{ padding: "6px 12px", borderRadius: 6, border: "1px solid " + c.border, background: c.surface, fontSize: 12, fontWeight: 600, cursor: "pointer", color: c.text2 }}>
                      Hoy
                    </button>
                  ) : null}
                </div>
              </div>
              <div style={{ maxHeight: 500, overflow: "auto" }}>
                <FilterTable
                  tableHead={["Unidad", "Placas", "Conductor", "Reparto", "Guias", "Entregadas", "Devueltas", "Pend.", "Avance", "Estado", ""]}
                  tableData={
                    detalle.items.length > 0
                      ? detalle.items.map(function (u) {
                          return [
                            u.unidad || "-",
                            u.placas || "-",
                            u.conductor || "-",
                            "#" + (u.folio_reparto || "-"),
                            u.total_guias || "0",
                            <span style={{ color: c.green, fontWeight: 600 }}>{u.guias_entregadas || "0"}</span>,
                            <span style={{ color: c.red, fontWeight: 600 }}>{u.guias_devueltas || "0"}</span>,
                            u.pendientes || "0",
                            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                              <div className={classes.progressTrack}>
                                <div className={classes.progressFill} style={{
                                  width: (u.porcentaje_avance || 0) + "%",
                                  background: (u.porcentaje_avance || 0) >= 80 ? c.green : (u.porcentaje_avance || 0) >= 50 ? c.amber : c.red
                                }} />
                              </div>
                              <span style={{ fontSize: 11, fontWeight: 600, color: c.text2 }}>{u.porcentaje_avance || 0}%</span>
                            </div>,
                            <span className={classes.badge + " " + (parseInt(u.liquidado) === 1 ? classes.bgGreen : classes.bgAmber)}>
                              {parseInt(u.liquidado) === 1 ? "LIQUIDADO" : "EN REPARTO"}
                            </span>,
                            <button
                              onClick={function () { verGuiasReparto(u.reparto_id, u.folio_reparto, u.unidad); }}
                              style={{ padding: "4px 10px", fontSize: 11, fontWeight: 600, border: "1px solid " + c.blue + "40", borderRadius: 6, background: c.blueBg, color: c.blue, cursor: "pointer", whiteSpace: "nowrap" }}
                            >
                              Ver Guias
                            </button>
                          ];
                        })
                      : [["Sin unidades", "", "", "", "", "", "", "", "", "", ""]]
                  }
                />
              </div>
            </div>

          ) : detalle && detalle.tipo === "UNIDADES_LOCALES_SUCURSAL" && detalle.items ? (
            <div>
              <p style={{ marginBottom: 12, color: c.text3, fontSize: 13 }}>{detalle.total} unidades en sucursal</p>
              <div style={{ maxHeight: 500, overflow: "auto" }}>
                <FilterTable
                  tableHead={["Unidad", "Placas", "Celular", "Ultimo Reparto", "Fecha", "Estado"]}
                  tableData={
                    detalle.items.length > 0
                      ? detalle.items.map(function (u) {
                          return [
                            u.unidad || "-",
                            u.placas || "-",
                            u.celular || "-",
                            u.ultimo_reparto || "-",
                            u.ultima_fecha || "-",
                            <span className={classes.badge + " " + (u.estado_reparto === "LIQUIDADO" ? classes.bgGreen : classes.bgAmber)}>
                              {u.estado_reparto || "-"}
                            </span>
                          ];
                        })
                      : [["Sin unidades", "", "", "", "", ""]]
                  }
                />
              </div>
            </div>

          ) : detalle && detalle.tipo === "EMBARQUES_HOY" && detalle.items ? (
            <div>
              <p style={{ marginBottom: 12, color: c.text3, fontSize: 13 }}>{detalle.total} embarques hoy</p>
              <div style={{ maxHeight: 500, overflow: "auto" }}>
                <FilterTable
                  tableHead={["Folio Embarque", "Folio Bitacora", "Unidad", "Fecha", "Ruta", "Guias"]}
                  tableData={
                    detalle.items.length > 0
                      ? detalle.items.map(function (e) {
                          return [e.folio_embarque || "-", e.folio_bitacora || "-", e.unidad || "-", e.fecha || "-", e.ruta || "-", e.total_guias || "0"];
                        })
                      : [["Sin embarques", "", "", "", "", ""]]
                  }
                />
              </div>
            </div>

          ) : detalle && detalle.tipo === "RECEPCIONES_HOY" && detalle.items ? (
            <div>
              <p style={{ marginBottom: 12, color: c.text3, fontSize: 13 }}>{detalle.total} recepciones hoy</p>
              <div style={{ maxHeight: 500, overflow: "auto" }}>
                <FilterTable
                  tableHead={["Folio Recepcion", "Folio Bitacora", "Unidad", "Fecha", "Ruta", "Guias"]}
                  tableData={
                    detalle.items.length > 0
                      ? detalle.items.map(function (r) {
                          return [r.folio_embarque || "-", r.folio_bitacora || "-", r.unidad || "-", r.fecha || "-", r.ruta || "-", r.total_guias || "0"];
                        })
                      : [["Sin recepciones", "", "", "", "", ""]]
                  }
                />
              </div>
            </div>

          ) : detalle && detalle.guias ? (
            <div>
              <p style={{ marginBottom: 12, color: c.text3, fontSize: 13 }}>{detalle.total} registros</p>
              <div style={{ maxHeight: 500, overflow: "auto" }}>
                <FilterTable
                  tableHead={["Guia", "Fecha", "Origen", "Destino", "Estado", "Peso", "Paq.", "Tipo", ""]}
                  tableData={
                    detalle.guias.length > 0
                      ? detalle.guias.slice(0, 200).map(function (g) {
                          return [
                            g.id || "-",
                            g.fecha || "-",
                            g.origen || "-",
                            g.destino || "-",
                            <span className={classes.badge + " " + getEstadoBadge(g.estado)}>{g.estado}</span>,
                            g.totalpeso ? parseFloat(g.totalpeso).toFixed(1) : "0",
                            g.totalpaquetes || "0",
                            g.tipo_guia === "V" ? "Vent." : "Emp.",
                            <EyeBtn guia={g.id} />
                          ];
                        })
                      : [["Sin registros", "", "", "", "", "", "", "", ""]]
                  }
                />
              </div>
            </div>

          ) : (
            <div style={{ textAlign: "center", padding: 40, color: c.text4 }}>
              <p>No se encontraron registros.</p>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* ═══════════════════════════════════════════════════════════
         MODAL — Guias de Reparto / Eficiencia
         ═══════════════════════════════════════════════════════════ */}
      <Dialog open={guiasModalOpen} TransitionComponent={Transition} keepMounted onClose={cerrarGuiasModal} maxWidth="lg" fullWidth
        PaperProps={{ style: { borderRadius: 12, maxHeight: "85vh" } }}>
        <DialogTitle disableTypography style={{ padding: "16px 20px 12px", borderBottom: "1px solid " + c.borderLight }}>
          <div className={classes.modalBar}>
            <span className={classes.modalTitle}>{guiasModalTitle}</span>
            <IconButton size="small" onClick={guiasEficiencia ? cerrarGuiasEficienciaModal : cerrarGuiasModal}><CloseIcon /></IconButton>
          </div>
        </DialogTitle>
        <DialogContent style={{ padding: "16px 20px 20px" }}>
          {(guiasRepartoLoading || guiasEficienciaLoading) ? (
            <div style={{ textAlign: "center", padding: "50px 0" }}>
              <CircularProgress size={28} style={{ color: c.blue }} />
              <p style={{ marginTop: 10, color: c.text4, fontSize: 13 }}>Cargando guias...</p>
            </div>

          ) : guiasEficiencia ? (
            <div>
              <p style={{ marginBottom: 12, color: c.text3, fontSize: 13 }}>{guiasEficiencia.guias ? guiasEficiencia.guias.length : 0} guias</p>
              <div style={{ maxHeight: 500, overflow: "auto" }}>
                <FilterTable
                  tableHead={["Guia", "Fecha", "Remitente", "Destinatario", "Estado", "Paq.", "Peso", ""]}
                  tableData={
                    guiasEficiencia.guias && guiasEficiencia.guias.length > 0
                      ? guiasEficiencia.guias.slice(0, 500).map(function (g) {
                          return [
                            g.guia || g.id || "-",
                            g.fecha || "-",
                            g.remitente || "-",
                            g.destinatario || "-",
                            <span className={classes.badge + " " + (g.estado_entrega === "E" ? classes.bgGreen : g.estado_entrega === "D" ? classes.bgRed : classes.bgAmber)}>
                              {g.estado_entrega === "E" ? "Entregada" : g.estado_entrega === "D" ? "Despues" : "Pendiente"}
                            </span>,
                            g.paquetes || g.totalpaquetes || "0",
                            g.peso ? parseFloat(g.peso).toFixed(1) : g.totalpeso ? parseFloat(g.totalpeso).toFixed(1) : "0",
                            <EyeBtn guia={g.guia || g.id} />
                          ];
                        })
                      : [["Sin guias", "", "", "", "", "", "", ""]]
                  }
                />
              </div>
            </div>

          ) : guiasReparto && guiasReparto.guias ? (
            <div>
              {/* Summary strip */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8, marginBottom: 14 }}>
                <div style={{ textAlign: "center", padding: "10px 8px", background: c.blueBg, borderRadius: 8 }}>
                  <p style={{ margin: 0, fontSize: 10, fontWeight: 700, color: c.text4, textTransform: "uppercase" }}>Total</p>
                  <p style={{ margin: "4px 0 0", fontSize: 20, fontWeight: 700, color: c.blue }}>{guiasReparto.total}</p>
                </div>
                <div style={{ textAlign: "center", padding: "10px 8px", background: c.greenBg, borderRadius: 8 }}>
                  <p style={{ margin: 0, fontSize: 10, fontWeight: 700, color: c.text4, textTransform: "uppercase" }}>Entregadas</p>
                  <p style={{ margin: "4px 0 0", fontSize: 20, fontWeight: 700, color: c.green }}>{guiasReparto.entregadas}</p>
                </div>
                <div style={{ textAlign: "center", padding: "10px 8px", background: c.redBg, borderRadius: 8 }}>
                  <p style={{ margin: 0, fontSize: 10, fontWeight: 700, color: c.text4, textTransform: "uppercase" }}>Devueltas</p>
                  <p style={{ margin: "4px 0 0", fontSize: 20, fontWeight: 700, color: c.red }}>{guiasReparto.devueltas}</p>
                </div>
                <div style={{ textAlign: "center", padding: "10px 8px", background: c.amberBg, borderRadius: 8 }}>
                  <p style={{ margin: 0, fontSize: 10, fontWeight: 700, color: c.text4, textTransform: "uppercase" }}>Pendientes</p>
                  <p style={{ margin: "4px 0 0", fontSize: 20, fontWeight: 700, color: c.amber }}>{guiasReparto.pendientes}</p>
                </div>
              </div>

              {/* Progress */}
              {guiasReparto.total > 0 ? (
                <div style={{ marginBottom: 14 }}>
                  <div style={{ display: "flex", height: 8, borderRadius: 4, overflow: "hidden", background: c.borderLight }}>
                    <div style={{ width: ((guiasReparto.entregadas / guiasReparto.total) * 100) + "%", background: c.green }} />
                    <div style={{ width: ((guiasReparto.devueltas / guiasReparto.total) * 100) + "%", background: c.red }} />
                  </div>
                </div>
              ) : null}

              <div style={{ maxHeight: 420, overflow: "auto" }}>
                <FilterTable
                  tableHead={["Guia", "Estado", "Remitente", "Destinatario", "Paq.", "Peso", "Recibe", "Entrega", ""]}
                  tableData={
                    guiasReparto.guias.length > 0
                      ? guiasReparto.guias.map(function (g) {
                          return [
                            g.guia || "-",
                            <div>
                              <span className={classes.badge + " " + (g.estado_app === "E" ? classes.bgGreen : g.estado_app === "D" ? classes.bgRed : classes.bgAmber)}>
                                {g.estado_texto}
                              </span>
                              {g.estado_app === "D" && g.motivo ? (
                                <div style={{ fontSize: 10, color: c.red, marginTop: 3 }}>{g.motivo}</div>
                              ) : null}
                            </div>,
                            g.remitente || "-",
                            g.destinatario || "-",
                            g.paquetes || "0",
                            g.peso ? parseFloat(g.peso).toFixed(1) : "0",
                            g.recibe || "-",
                            g.fecha_entrega || "-",
                            <EyeBtn guia={g.guia} />
                          ];
                        })
                      : [["Sin guias", "", "", "", "", "", "", "", ""]]
                  }
                />
              </div>
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: 40, color: c.text4 }}>
              <p>No se encontraron guias.</p>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* ═══════════════════════════════════════════════════════════
         MODAL — Detalles de Guia
         ═══════════════════════════════════════════════════════════ */}
      <Dialog open={guiaDetallesModalOpen} TransitionComponent={Transition} keepMounted onClose={cerrarDetallesGuia} maxWidth="md" fullWidth
        PaperProps={{ style: { borderRadius: 12, maxHeight: "85vh" } }}>
        <DialogTitle disableTypography style={{ padding: "16px 20px 12px", borderBottom: "1px solid " + c.borderLight }}>
          <div className={classes.modalBar}>
            <div>
              <span className={classes.modalTitle}>
                {guiaDetalles && guiaDetalles.resultado && guiaDetalles.resultado.datos
                  ? "Guia #" + guiaDetalles.resultado.datos.id
                  : "Detalles de Guia"}
              </span>
              {guiaDetalles && guiaDetalles.resultado && guiaDetalles.resultado.datos && (
                <p style={{ margin: "2px 0 0", fontSize: 12, color: c.text4 }}>{guiaDetalles.resultado.datos.fecha}</p>
              )}
            </div>
            <IconButton size="small" onClick={cerrarDetallesGuia}><CloseIcon /></IconButton>
          </div>
        </DialogTitle>
        <DialogContent style={{ padding: "16px 20px 24px" }}>
          {guiaDetallesLoading ? (
            <div style={{ textAlign: "center", padding: "50px 0" }}>
              <CircularProgress size={28} style={{ color: c.blue }} />
              <p style={{ marginTop: 10, color: c.text4, fontSize: 13 }}>Cargando detalles...</p>
            </div>
          ) : guiaDetalles && guiaDetalles.resultado && guiaDetalles.resultado.datos ? (
            <div>
              {/* Tags */}
              <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap" }}>
                <span className={classes.badge + " " + classes.bgBlue}>{guiaDetalles.resultado.datos.estado || "N/A"}</span>
                {guiaDetalles.resultado.datos.tipoflete && (
                  <span className={classes.badge + " " + classes.bgGreen}>{guiaDetalles.resultado.datos.tipoflete}</span>
                )}
                {guiaDetalles.resultado.datos.tipopago && (
                  <span className={classes.badge + " " + classes.bgViolet}>{guiaDetalles.resultado.datos.tipopago}</span>
                )}
                {guiaDetalles.resultado.datos.origen && guiaDetalles.resultado.datos.destino && (
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 600, background: c.borderLight, color: c.text2 }}>
                    {guiaDetalles.resultado.datos.origen} → {guiaDetalles.resultado.datos.destino}
                  </span>
                )}
              </div>

              {/* Metrics */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 16 }}>
                <div style={{ textAlign: "center", padding: "12px 8px", background: c.blueBg, borderRadius: 8 }}>
                  <p style={{ margin: 0, fontSize: 10, fontWeight: 700, color: c.text4, textTransform: "uppercase" }}>Paquetes</p>
                  <p style={{ margin: "4px 0 0", fontSize: 22, fontWeight: 800, color: c.blue }}>{guiaDetalles.resultado.datos.totalpaquetes || "0"}</p>
                </div>
                <div style={{ textAlign: "center", padding: "12px 8px", background: c.greenBg, borderRadius: 8 }}>
                  <p style={{ margin: 0, fontSize: 10, fontWeight: 700, color: c.text4, textTransform: "uppercase" }}>Peso</p>
                  <p style={{ margin: "4px 0 0", fontSize: 22, fontWeight: 800, color: c.green }}>
                    {guiaDetalles.resultado.datos.totalpeso ? parseFloat(guiaDetalles.resultado.datos.totalpeso).toFixed(1) : "0"} <span style={{ fontSize: 12, fontWeight: 500 }}>kg</span>
                  </p>
                </div>
                <div style={{ textAlign: "center", padding: "12px 8px", background: c.cyanBg, borderRadius: 8 }}>
                  <p style={{ margin: 0, fontSize: 10, fontWeight: 700, color: c.text4, textTransform: "uppercase" }}>Volumen</p>
                  <p style={{ margin: "4px 0 0", fontSize: 22, fontWeight: 800, color: c.cyan }}>
                    {guiaDetalles.resultado.datos.totalvolumen ? parseFloat(guiaDetalles.resultado.datos.totalvolumen).toFixed(2) : "0"} <span style={{ fontSize: 12, fontWeight: 500 }}>m3</span>
                  </p>
                </div>
              </div>

              {/* Remitente / Destinatario */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
                <div style={{ padding: 14, borderRadius: 8, border: "1px solid " + c.border }}>
                  <p style={{ margin: "0 0 6px", fontSize: 10, fontWeight: 700, color: c.text4, textTransform: "uppercase", letterSpacing: "0.3px" }}>
                    <ArrowUpwardIcon style={{ fontSize: 12, verticalAlign: "middle", marginRight: 4 }} />Remitente
                  </p>
                  <p style={{ margin: "0 0 4px", fontWeight: 700, fontSize: 14, color: c.text1 }}>{guiaDetalles.resultado.datos.remitente || "-"}</p>
                  {guiaDetalles.resultado.datos.remcalle && (
                    <p style={{ margin: "0 0 4px", fontSize: 12, color: c.text3, lineHeight: 1.4 }}>
                      {guiaDetalles.resultado.datos.remcalle} {guiaDetalles.resultado.datos.remnumero}, {guiaDetalles.resultado.datos.remcolonia}
                      {guiaDetalles.resultado.datos.remcp && ", CP " + guiaDetalles.resultado.datos.remcp}
                      <br/>{guiaDetalles.resultado.datos.remmunicipio}, {guiaDetalles.resultado.datos.remestado}
                    </p>
                  )}
                  {guiaDetalles.resultado.datos.remcelular && (
                    <p style={{ margin: "4px 0 0", fontSize: 11, color: c.text2 }}>Tel: {guiaDetalles.resultado.datos.remcelular}</p>
                  )}
                  {guiaDetalles.resultado.datos.rememail && (
                    <p style={{ margin: "2px 0 0", fontSize: 11, color: c.text2 }}>{guiaDetalles.resultado.datos.rememail}</p>
                  )}
                </div>
                <div style={{ padding: 14, borderRadius: 8, border: "1px solid " + c.border }}>
                  <p style={{ margin: "0 0 6px", fontSize: 10, fontWeight: 700, color: c.text4, textTransform: "uppercase", letterSpacing: "0.3px" }}>
                    <ArrowDownwardIcon style={{ fontSize: 12, verticalAlign: "middle", marginRight: 4 }} />Destinatario
                  </p>
                  <p style={{ margin: "0 0 4px", fontWeight: 700, fontSize: 14, color: c.text1 }}>{guiaDetalles.resultado.datos.destinatario || "-"}</p>
                  {guiaDetalles.resultado.datos.descalle && (
                    <p style={{ margin: "0 0 4px", fontSize: 12, color: c.text3, lineHeight: 1.4 }}>
                      {guiaDetalles.resultado.datos.descalle} {guiaDetalles.resultado.datos.desnumero}, {guiaDetalles.resultado.datos.descolonia}
                      {guiaDetalles.resultado.datos.descp && ", CP " + guiaDetalles.resultado.datos.descp}
                      <br/>{guiaDetalles.resultado.datos.desmunicipio}, {guiaDetalles.resultado.datos.desestado}
                    </p>
                  )}
                  {guiaDetalles.resultado.datos.descelular && (
                    <p style={{ margin: "4px 0 0", fontSize: 11, color: c.text2 }}>Tel: {guiaDetalles.resultado.datos.descelular}</p>
                  )}
                  {guiaDetalles.resultado.datos.desemail && (
                    <p style={{ margin: "2px 0 0", fontSize: 11, color: c.text2 }}>{guiaDetalles.resultado.datos.desemail}</p>
                  )}
                </div>
              </div>

              {/* Fechas */}
              {(guiaDetalles.resultado.datos.fechaposibleentrega || guiaDetalles.resultado.datos.fechaentrega || guiaDetalles.resultado.ead) && (
                <div style={{ display: "flex", gap: 16, marginBottom: 16, padding: "10px 14px", background: c.surfaceHover, borderRadius: 8, flexWrap: "wrap" }}>
                  {guiaDetalles.resultado.datos.fechaposibleentrega && (
                    <div style={{ minWidth: 120 }}>
                      <p style={{ margin: 0, fontSize: 10, color: c.text4, fontWeight: 600 }}>ENTREGA ESTIMADA</p>
                      <p style={{ margin: "2px 0 0", fontSize: 13, fontWeight: 600, color: c.text1 }}>{guiaDetalles.resultado.datos.fechaposibleentrega}</p>
                    </div>
                  )}
                  {guiaDetalles.resultado.datos.fechaentrega && (
                    <div style={{ minWidth: 120 }}>
                      <p style={{ margin: 0, fontSize: 10, color: c.green, fontWeight: 600 }}>ENTREGADA</p>
                      <p style={{ margin: "2px 0 0", fontSize: 13, fontWeight: 600, color: c.green }}>{guiaDetalles.resultado.datos.fechaentrega}</p>
                    </div>
                  )}
                  {guiaDetalles.resultado.ead && (
                    <div style={{ minWidth: 120 }}>
                      <p style={{ margin: 0, fontSize: 10, color: c.green, fontWeight: 600 }}>RECIBIO</p>
                      <p style={{ margin: "2px 0 0", fontSize: 13, fontWeight: 600, color: c.text1 }}>{guiaDetalles.resultado.ead.recibe || "-"}</p>
                      {guiaDetalles.resultado.ead.fechaead && (
                        <p style={{ margin: "2px 0 0", fontSize: 11, color: c.text4 }}>{guiaDetalles.resultado.ead.fechaead}</p>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Paquetes */}
              {guiaDetalles.resultado.detalle && guiaDetalles.resultado.detalle.length > 0 && (
                <div>
                  <p style={{ margin: "0 0 8px", fontSize: 10, fontWeight: 700, color: c.text4, textTransform: "uppercase", letterSpacing: "0.3px" }}>Detalle de Paquetes</p>
                  {guiaDetalles.resultado.detalle.map(function(paq, idx) {
                    return (
                      <div key={idx} style={{ padding: "10px 12px", background: c.surfaceHover, borderRadius: 6, marginBottom: 6, border: "1px solid " + c.borderLight }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                          <span style={{ fontSize: 13, fontWeight: 700, color: c.text1 }}>
                            {paq.cantidad} {paq.descripcion}
                          </span>
                          <span style={{ fontSize: 10, fontWeight: 600, color: c.text4, background: c.surface, padding: "2px 8px", borderRadius: 4 }}>
                            {paq.contenido || "N/A"}
                          </span>
                        </div>
                        <div style={{ display: "flex", gap: 12, fontSize: 11, color: c.text3 }}>
                          <span>Peso: <strong style={{ color: c.text1 }}>{paq.peso ? parseFloat(paq.peso).toFixed(1) + " kg" : "-"}</strong></span>
                          <span>Vol: <strong style={{ color: c.text1 }}>{paq.volumen ? parseFloat(paq.volumen).toFixed(2) + " m3" : "-"}</strong></span>
                          {paq.alto && paq.ancho && paq.largo && (
                            <span>Dim: <strong style={{ color: c.text1 }}>{paq.alto}x{paq.ancho}x{paq.largo} cm</strong></span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Comentarios devolucion */}
              {guiaDetalles.resultado.ead && guiaDetalles.resultado.ead.motivodevolucion && (
                <div style={{ marginTop: 14, padding: "10px 14px", background: c.amberBg, borderRadius: 8, borderLeft: "3px solid " + c.amber }}>
                  <p style={{ margin: "0 0 4px", fontSize: 10, fontWeight: 700, color: c.amber, textTransform: "uppercase" }}>Comentarios</p>
                  <p style={{ margin: 0, fontSize: 12, color: c.text1 }}>{guiaDetalles.resultado.ead.motivodevolucion}</p>
                </div>
              )}
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: 40, color: c.text4 }}>
              <p>No se encontraron detalles.</p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════
   REDUX
   ═══════════════════════════════════════════════════════════════ */
var mapStateToProps = function (state) {
  return {
    tableroData: state.tableroControl.tablero_Data,
    tableroError: state.tableroControl.tablero_Error,
    tableroLoading: state.tableroControl.tablero_Loading,
    tableroDetalle: state.tableroControl.tablero_Detalle,
    tableroDetalleLoading: state.tableroControl.tablero_Detalle_Loading,
    tableroGuiasReparto: state.tableroControl.tablero_GuiasReparto,
    tableroGuiasRepartoLoading: state.tableroControl.tablero_GuiasReparto_Loading,
    tableroEficiencia: state.tableroControl.tablero_Eficiencia,
    tableroEficienciaLoading: state.tableroControl.tablero_Eficiencia_Loading,
    tableroGuiasEficiencia: state.tableroControl.tablero_GuiasEficiencia,
    tableroGuiasEficienciaLoading: state.tableroControl.tablero_GuiasEficiencia_Loading,
    tableroGuiaDetalles: state.tableroControl.tablero_GuiaDetalles,
    tableroGuiaDetallesLoading: state.tableroControl.tablero_GuiaDetalles_Loading
  };
};

var mapDispatchToProps = function (dispatch) {
  return {
    getTableroResumen: function (sucursal) { dispatch(getTableroResumen(sucursal)); },
    getTableroDetalle: function (sucursal, type, fecha) { dispatch(getTableroDetalle(sucursal, type, fecha)); },
    limpiarDetalle: function () { dispatch(limpiarDetalle()); },
    getTableroGuiasReparto: function (sucursal, folioReparto) { dispatch(getTableroGuiasReparto(sucursal, folioReparto)); },
    limpiarGuiasReparto: function () { dispatch(limpiarGuiasReparto()); },
    getTableroEficiencia: function (sucursal) { dispatch(getTableroEficiencia(sucursal)); },
    getTableroGuiasEficiencia: function (sucursal, filtroEstado) { dispatch(getTableroGuiasEficiencia(sucursal, filtroEstado)); },
    limpiarGuiasEficiencia: function () { dispatch(limpiarGuiasEficiencia()); },
    getGuiaDetalles: function (numeroGuia) { dispatch(getGuiaDetalles(numeroGuia)); },
    limpiarGuiaDetalles: function () { dispatch(limpiarGuiaDetalles()); }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TableroControl);
